import { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkBreaks from 'remark-breaks';
import { api } from '../api/client';
import type { TranscriptMessage } from '../types';

/** Read-only report history. Never connects the live composer or changes the active session. */
export function FullTranscript({ assessmentId, sample }: { assessmentId: string; sample: boolean }) {
  const [messages, setMessages] = useState<TranscriptMessage[] | null>(null);
  const [failed, setFailed] = useState(false);
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    let cancelled = false;
    setMessages(null);
    setFailed(false);
    if (!sample) {
      api.getSession(assessmentId).then(({ messages: saved }) => {
        if (!cancelled) setMessages(saved);
      }).catch(() => { if (!cancelled) setFailed(true); });
    }
    return () => { cancelled = true; };
  }, [assessmentId, sample, attempt]);

  return (
    <section id="full-transcript" aria-label="Full transcript" style={{ marginTop: 20, padding: 20, borderRadius: 8, background: '#fff', color: '#333544' }}>
      <h2 style={{ fontSize: 20, margin: '0 0 12px' }}>Full transcript</h2>
      <p>This is a read-only record of this assessment. It is not included in the manager summary.</p>
      {sample ? <p>No transcript is available for this sample report.</p>
        : failed ? <div role="alert"><p>Could not load the transcript.</p><button onClick={() => setAttempt((n) => n + 1)} style={{ padding: 8, textDecoration: 'underline' }}>Retry loading transcript</button></div>
          : messages === null ? <p role="status">Loading transcript…</p>
            : messages.length === 0 ? <p>No transcript is available for this assessment. It may be a historical import or no longer retained.</p>
              : <ol style={{ listStyle: 'none', padding: 0, maxHeight: '65vh', overflowY: 'auto' }} tabIndex={0} aria-label="Assessment conversation">
                {messages.map((message, index) => (
                  <li key={`${message.ts}-${index}`} style={{ padding: 16, marginTop: 12, borderRadius: 6, background: message.role === 'user' ? '#F4F4F6' : '#F6FCF6', overflowWrap: 'anywhere' }}>
                    <strong>{message.role === 'user' ? 'You' : 'Avery'}</strong>
                    <div style={{ marginTop: 8 }}>
                      {message.role === 'user' ? <p style={{ whiteSpace: 'pre-wrap', margin: 0 }}>{message.text}</p>
                        : <ReactMarkdown remarkPlugins={[remarkBreaks]} skipHtml components={{ img: ({ alt }) => <span>{alt}</span> }}>{message.text}</ReactMarkdown>}
                    </div>
                  </li>
                ))}
              </ol>}
    </section>
  );
}
